import { range } from 'lodash'
import { z } from 'zod'

import SelectBase from '@/components/Form/Atoms/SelectBase/SelectBase'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

export const deliveryHourDefaultValue = '18_20'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: '配送間隔' })

const baseHour = 12
export const deliveryHourInputKey = InputKey(
  'deliveryHour',
  formResolverUtils.enum({
    unspecified: 'unspecified',
    morning: 'morning',
    ...Object.fromEntries(
      [...range(4).map((value) => `${baseHour + 2 * value}_${baseHour + 2 * (value + 1)}`), '19_21'].map((value) => [
        value,
        value,
      ])
    ),
  }).schema
)

const options = [
  { label: '指定なし', value: 'unspecified' },
  { label: '午前', value: 'morning' },
  ...range(4).map((value) => ({
    label: `${baseHour + 2 * value}時-${baseHour + 2 * (value + 1)}時`,
    value: `${baseHour + 2 * value}_${baseHour + 2 * (value + 1)}`,
  })),
  { label: '19時-21時', value: '19_21' },
]

export const i18n = (value: string): string => {
  const map = Object.fromEntries(
    options.map((option) => {
      return [option.value, option.label]
    })
  )

  // @ts-ignore
  return map[value]
}

export const generateLabel = (value: string) => {
  return Object.fromEntries(
    options.map((option) => {
      return [option.value, option.label]
    })
  )[value]
}

const DeliveryIntervalInput = () => {
  return <SelectBase name={deliveryHourInputKey.name} options={options} />
}

export default DeliveryIntervalInput
